export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    sortable: false,
    sortField: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
    tdClass: 'limit-size',
  },
  {
    key: 'username',
    sortable: false,
    sortField: 'username',
    label: 'field.username',
  },
  {
    key: 'turnover',
    sortable: false,
    sortField: '',
    label: 'field.turnover',
    tdClass: 'text-right',
  },
  {
    key: 'newWl',
    sortable: false,
    sortField: '',
    label: 'field.newWinLoss',
    tdClass: 'text-right',
  },
  {
    key: 'deposit',
    sortable: false,
    sortField: '',
    label: 'field.deposit',
    tdClass: 'text-right',
  },
  {
    key: 'withdrawal',
    sortable: false,
    sortField: '',
    label: 'field.withdraw',
    tdClass: 'text-right',
  },
  {
    key: 'balance',
    sortable: false,
    sortField: '',
    label: 'field.balance',
    tdClass: 'text-right text-brand',
  },
  {
    key: 'outstanding1',
    sortable: false,
    sortField: '',
    label: 'field.outstanding1',
    tdClass: 'text-center',
  },
  {
    key: 'outstanding2',
    sortable: false,
    sortField: '',
    label: 'field.outstanding2',
    tdClass: 'text-center',
  },
  {
    key: 'outstanding5',
    sortable: false,
    sortField: '',
    label: 'field.outstanding3',
    tdClass: 'text-center',
  },
  {
    key: 'outstanding6',
    sortable: false,
    sortField: '',
    label: 'field.outstanding4',
    tdClass: 'text-center',
  },
  {
    key: 'outstanding7',
    sortable: false,
    sortField: '',
    label: 'field.outstanding5',
    tdClass: 'text-center',
  },
  {
    key: 'isVendor',
    label: 'field.playerType',
  },
  {
    key: 'status',
    sortable: false,
    sortField: '',
    label: 'field.status',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
];
